// todo move this file to module
export let showPreFactorOptions = {
    '1': 'نمایش داده شود',
    '0': 'مخفی',
}